import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from 'classnames';
import styles from './index.module.scss.js';
import { Divider } from '../../general/Divider/index.js';
import { Box } from '../Box/index.js';

const Stack = ({ as = 'div', children, direction = 'column', spacing, alignItems, justifyContent, flexWrap, dividers, 
// Allow this component to have external styles.
// Only applied to this component as it will be used as a wrapper.
// eslint-disable-next-line no-restricted-syntax
className, ...props }) => {
    var _a;
    const childrenArray = (_a = React__default.Children) === null || _a === void 0 ? void 0 : _a.toArray(children);
    const orientation = direction.includes('column') ? 'horizontal' : 'vertical';
    return (jsx(Box, { as: as, className: classNames(className, styles.stack, styles[`stack__${direction}`], !!spacing && styles[`stack__spacing_${spacing}`], !!alignItems && styles[`stack__alignItems_${alignItems}`], !!justifyContent && styles[`stack__justifyContent_${justifyContent}`], !!flexWrap && styles.stack__flexWrap), ...props, children: dividers ? (jsx(Fragment, { children: childrenArray.map((child, index) => (
            // eslint-disable-next-line react/no-array-index-key
            jsxs(React__default.Fragment, { children: [child, index < childrenArray.length - 1 && (jsx(Divider, { orientation: orientation, type: "padded", flexItem: true }))] }, index))) })) : (jsx(Fragment, { children: children })) }));
};

export { Stack };
